import SystemApiBase from "../base/SystemApiBase";

import { type ApiVersion } from "@/schemas/app/version";
import type { SupportedAppNotifications } from "@/schemas/notification/internal";

export type UserAttributeValues = {
  attribute_type: string;
  values: string[];
};

export type UserAttributeResponse = {
  attributes: UserAttributeValues[];
};

class SystemService extends SystemApiBase {
  public constructor() {
    super("/system");
  }

  public getUserAttributeValues(): Promise<UserAttributeResponse> {
    return this.get<UserAttributeResponse>("/attributes");
  }

  public getSupportedAppNotifications(): Promise<SupportedAppNotifications> {
    return this.get<SupportedAppNotifications>("/notification");
  }

  public async getSupportedVersion(): Promise<ApiVersion> {
    return this.get<ApiVersion>("/version");
  }
}

export default SystemService;
